/** Gerado automaticamente a partir de package.json — não editar manualmente. */
export const APP_VERSION = '1.6.1';
